import Immutable from "immutable";
const LOAD = "sageAccounts/LOAD";
const LOAD_SUCCESS = "sageAccounts/LOAD_SUCCESS";
const LOAD_FAIL = "sageAccounts/LOAD_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  sageAccounts: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("notes", action.res);

    case LOAD_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("notes", null);

    default:
      return state;
  }
}

export const getSageAccounts = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/sageAccount`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
